import { useState, useCallback } from "react";

export function useNotify() {
  const [notify, setNotify] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const show = useCallback((severity: string, message: string) => {
    setNotify({
      open: true,
      severity,
      message,
    });
  }, []);

  const success = useCallback(
    (message: string) => show("success", message),
    [show]
  );

  const error = useCallback(
    (message: string) => show("error", message),
    [show]
  );

  const warning = useCallback(
    (message: string) => show("warning", message),
    [show]
  );

  const info = useCallback(
    (message: string) => show("info", message),
    [show]
  );

  const close = useCallback(() => {
    setNotify((n) => ({ ...n, open: false }));
  }, []);

  return {
    notify,
    success,
    error,
    warning,
    info,
    close,
  };
}